module.exports = __webpack_public_path__ + "static/media/logo-youan@2x.ed9789ee.png";